export const environment = ["localhost", "dev", "qa", "mo", "prod"] as const;

export type Environment = (typeof environment)[number];
